/**
 * @desc 查看节假日详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.HolidayManagementListResponseDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/holidayManagement/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
